(function () {
  'use strict';

  const instances = new WeakMap();

  const debounce = (fn, delay = 100) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  };

  const equalizeHeights = (section) => {
    const cards = Array.from(section.querySelectorAll('.custom-grid-layout__card'));
    if (!cards.length) return;

    cards.forEach((card) => {
      card.style.minHeight = '0px';
    });

    let maxHeight = 0;
    cards.forEach((card) => {
      const height = card.getBoundingClientRect().height;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    cards.forEach((card) => {
      card.style.minHeight = `${maxHeight}px`;
    });
  };

  const initCarousel = (section) => {
    const track = section.querySelector('[data-carousel-track]');
    const prevButton = section.querySelector('[data-carousel-prev]');
    const nextButton = section.querySelector('[data-carousel-next]');

    if (!track || !prevButton || !nextButton) return null;

    const getScrollStep = () => {
      const firstItem = track.querySelector('.custom-grid-layout__item');
      if (!firstItem) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return firstItem.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      prevButton.disabled = track.scrollLeft <= 1;
      nextButton.disabled = track.scrollLeft >= maxScroll - 1 || maxScroll <= 0;
    };

    const onPrev = () => track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
    const onNext = () => track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
    const onScroll = debounce(updateButtons, 40);

    prevButton.addEventListener('click', onPrev);
    nextButton.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });

    updateButtons();

    return {
      update: updateButtons,
      destroy: () => {
        prevButton.removeEventListener('click', onPrev);
        nextButton.removeEventListener('click', onNext);
        track.removeEventListener('scroll', onScroll);
      }
    };
  };

  const setupSection = (section) => {
    if (instances.has(section)) return;

    equalizeHeights(section);

    const carousel = initCarousel(section);

    const onResize = debounce(() => {
      equalizeHeights(section);
      if (carousel) carousel.update();
    }, 150);

    window.addEventListener('resize', onResize, { passive: true });

    const observer = new ResizeObserver(onResize);
    observer.observe(section);

    instances.set(section, {
      carousel,
      observer,
      onResize
    });
  };

  const teardownSection = (section) => {
    const instance = instances.get(section);
    if (!instance) return;

    if (instance.carousel) instance.carousel.destroy();
    if (instance.observer) instance.observer.disconnect();
    window.removeEventListener('resize', instance.onResize);

    instances.delete(section);
  };

  const initAll = () => {
    document.querySelectorAll('.custom-grid-layout').forEach(setupSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.custom-grid-layout');
    if (section) setupSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.custom-grid-layout');
    if (section) teardownSection(section);
  });
})();
